(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  const removableLocaleParams = ['locale', '_cb'];

  const getThemeAssetUrl = (filename) => {
    const assetNode = document.querySelector('link[href*="/assets/"], script[src*="/assets/"], img[src*="/assets/"]');
    const assetUrl = assetNode && (assetNode.getAttribute('href') || assetNode.getAttribute('src'));
    if (!assetUrl) return '';
    return assetUrl.replace(/\/assets\/[^?]+(\?.*)?$/, `/assets/${filename}`);
  };

  const getLocalizedUrl = (localeCode) => {
    const url = new URL(window.location.href);
    const isEnglishPath = url.pathname === '/en' || url.pathname.startsWith('/en/');

    removableLocaleParams.forEach((param) => url.searchParams.delete(param));

    if (localeCode === 'en') {
      url.pathname = isEnglishPath ? url.pathname : `/en${url.pathname === '/' ? '' : url.pathname}`;
    }

    if (localeCode === 'ja') {
      url.pathname = isEnglishPath ? url.pathname.replace(/^\/en(?=\/|$)/, '') || '/' : url.pathname;
    }

    return url.toString();
  };

  const initLanguageSwitcher = () => {
    if (window.__kokiLanguageSwitcherReady) return;
    window.__kokiLanguageSwitcherReady = true;

    document.addEventListener('click', (event) => {
      const option = event.target.closest('.disclosure--option[data-value="en"], .disclosure--option[data-value="ja"]');
      if (!option) return;

      const form = option.closest('form');
      const isLocalizationOption = form && /\/localization(?:$|\?)/.test(form.getAttribute('action') || '');
      if (!isLocalizationOption) return;

      const localeCode = option.getAttribute('data-value');
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.href = getLocalizedUrl(localeCode);
    }, true);
  };

  const applyKokiLiveFixes = () => {
    if (!document.getElementById('koki-live-fix-style')) {
      const style = document.createElement('style');
      style.id = 'koki-live-fix-style';
      style.textContent = `
        .header--wrapper{position:relative!important;display:grid!important;grid-template-columns:minmax(92px,auto) 1fr minmax(64px,auto)!important;grid-template-areas:"logo nav language"!important;align-items:center!important;min-height:56px!important;padding-left:28px!important;padding-right:28px!important;column-gap:24px!important}
        .header--logo{grid-area:logo!important;justify-self:start!important}
        .header--primary-nav{grid-area:nav!important;justify-self:center!important;display:flex!important;min-width:0!important}
        .header--secondary-nav{grid-area:language!important;justify-self:end!important;margin-right:0!important}
        .template-index [id^="shopify-section-sections--27081622389034__header"] .header--primary-nav,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--primary-nav{justify-self:center!important}
        .header--primary-nav .x-menu--level-1--container{justify-content:center!important;gap:60px!important}
        .template-index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper::before,.template-index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper:before,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper::before,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper:before{content:none!important;display:none!important}
        .header--primary-nav .x-menu--level-1--link:first-child{display:none!important}
        .header--primary-nav .x-menu--level-1--link:nth-child(n+6){display:none!important}
        .header--cart,.header--account,.header--search,.header--search-container{display:none!important}
        .koki-footer{display:block!important;visibility:visible!important;opacity:1!important}
        .koki-home-hit{position:absolute!important;left:28px!important;top:0!important;z-index:3!important;width:104px!important;height:56px!important;display:block!important}
        .koki-contact__title,.koki-reservation__title,.koki-store__title,.koki-page-content__title,.koki-exhibition__title,.koki-product-title{font-size:22px!important;font-weight:500!important}
        .koki-contact__required{color:transparent!important;font-size:0!important;line-height:1!important}
        .koki-contact__required::after{content:"*"!important;color:#000!important;font-size:12px!important;line-height:1!important}
        .koki-btn-cart{display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#fff!important;text-align:center!important;text-decoration:none!important;line-height:1.4!important}
        .koki-btn-cart:visited,.koki-btn-cart:hover,.koki-btn-cart:focus{color:#fff!important}
        .koki-btn-cart-full{width:100%!important}
        .koki-product-meta{display:grid!important;gap:8px!important;margin:0 0 36px!important;padding:18px 0!important;border-top:1px solid #e0e0e0!important;border-bottom:1px solid #e0e0e0!important;font-size:12px!important;line-height:1.7!important;letter-spacing:.04em!important}
        .koki-product-meta-row{display:grid!important;grid-template-columns:110px 1fr!important;gap:16px!important}
        .koki-product-meta-term{color:#666!important}
        .koki-product-meta-value{color:#000!important}
        @media(max-width:767px){.koki-product-meta-row{grid-template-columns:92px 1fr!important;gap:12px!important}}
        @media(max-width:767px){.header--root{padding-left:0!important;padding-right:0!important}.header--wrapper{grid-template-columns:minmax(80px,1fr) auto auto!important;grid-template-areas:"logo language drawer"!important;min-height:54px!important;padding-left:15px!important;padding-right:15px!important}.header--wrapper:before,.header--wrapper::before{content:none!important;display:none!important}.header--logo{grid-area:logo!important;display:flex!important;visibility:visible!important;opacity:1!important}.header--logo img{display:block!important;max-width:61px!important;height:auto!important}.header--primary-nav{display:contents!important}.header--primary-nav .x-menu{display:none!important}.header--drawer-toggle{grid-area:drawer!important;display:inline-flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:5px!important;justify-self:end!important;width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;padding:0!important;visibility:visible!important;opacity:1!important}.header--drawer-toggle span{display:block!important;width:22px!important;height:1px!important;min-width:22px!important;min-height:1px!important;background:#000!important}.koki-home-hit{left:15px!important;height:54px!important}.koki-top-mobile__wallet{aspect-ratio:335/335!important}.koki-top-mobile__wallet img{width:100%!important;height:100%!important;object-fit:cover!important}}
      `;
      document.head.appendChild(style);
    }

    document.querySelectorAll('.koki-top-mobile__solo').forEach((walletPanel) => {
      const image = walletPanel.querySelector('img');
      const walletSrc = getThemeAssetUrl('koki-top-sp-wallet-20260519.png');
      walletPanel.classList.remove('koki-top-mobile__solo');
      walletPanel.classList.add('koki-top-mobile__inset', 'koki-top-mobile__wallet');
      if (!image) return;
      if (walletSrc) image.setAttribute('src', walletSrc);
      image.classList.add('koki-top-img');
      image.setAttribute('width', '335');
      image.setAttribute('height', '335');
      image.setAttribute('alt', 'KOKI black wallet');
      image.style.setProperty('width', '100%', 'important');
      image.style.setProperty('height', '100%', 'important');
      image.style.setProperty('object-fit', 'cover', 'important');
    });

    document.querySelectorAll('.header--root a, .x-menu a, .y-menu a').forEach((link) => {
      const label = normalizeText(link.textContent);
      if (label === 'COLLECTIONS') link.setAttribute('href', '/collections/all');
      if (label === 'STORE') link.setAttribute('href', '/pages/store');
      if (label === 'CONTACT') link.setAttribute('href', '/pages/contact');
      if (label === 'OUR STORY') link.setAttribute('href', '/pages/our-story');
      if (label === 'HOME') link.setAttribute('href', '/');
    });

    document.querySelectorAll('.header--primary-nav .x-menu--level-1--link').forEach((item, index) => {
      item.style.setProperty('display', index >= 1 && index <= 4 ? 'flex' : 'none', 'important');
    });

    document.querySelectorAll('.koki-store__map[href="#"]').forEach((link) => {
      link.setAttribute('href', '/pages/store');
    });

    document.querySelectorAll('.koki-store__reserve[href="#"]').forEach((link) => {
      link.setAttribute('href', '/pages/reservation');
    });

    document.querySelectorAll('.koki-contact__required').forEach((marker) => {
      marker.textContent = '*';
    });

    document.querySelectorAll('.koki-btn-cart').forEach((button) => {
      button.style.setProperty('display', 'inline-flex', 'important');
      button.style.setProperty('align-items', 'center', 'important');
      button.style.setProperty('justify-content', 'center', 'important');
      button.style.setProperty('color', '#fff', 'important');
      button.style.setProperty('text-align', 'center', 'important');
      button.style.setProperty('text-decoration', 'none', 'important');
    });

    document.querySelectorAll('.koki-exhibition__regular').forEach((price) => {
      price.textContent = price.textContent.replace(/^Regular Price:/, '割引前金額:');
    });
    document.querySelectorAll('.koki-exhibition__special').forEach((price) => {
      price.textContent = price.textContent.replace(/^Exhibition Price:/, '販売価格:');
    });

    document.querySelectorAll('.koki-contact__title, .koki-reservation__title, .koki-store__title, .koki-page-content__title, .koki-exhibition__title, .koki-product-title').forEach((title) => {
      title.style.fontSize = '22px';
      title.style.fontWeight = '500';
    });

    document.querySelectorAll('.header--wrapper').forEach((wrapper) => {
      if (wrapper.querySelector('.koki-home-hit')) return;
      const homeHit = document.createElement('a');
      homeHit.className = 'koki-home-hit';
      homeHit.href = '/';
      homeHit.setAttribute('aria-label', 'HOME');
      wrapper.appendChild(homeHit);
    });
  };

  ready(() => {
    initLanguageSwitcher();
    applyKokiLiveFixes();
    window.setTimeout(applyKokiLiveFixes, 250);
    window.setTimeout(applyKokiLiveFixes, 1000);
  });

  document.addEventListener('shopify:section:load', applyKokiLiveFixes);
})();
